export default function BookingSlotPicker({ slots, onPick, serviceId }) {
  if (!slots || slots.length === 0) return null;
  return (
    <div className="mt-4">
      <div className="label-mystic mb-2">Available Slots</div>
      <div className="flex flex-wrap gap-2">
        {slots.slice(0, 6).map((slot) => (
          <button key={slot} onClick={() => onPick(slot)}
            className="text-xs border border-secondary/30 hover:bg-secondary/10 px-3 py-1.5 rounded-sm text-secondary"
            data-testid={`slot-${serviceId}-${slot}`}>
            {new Date(slot).toLocaleString([], { dateStyle: "medium", timeStyle: "short" })}
          </button>
        ))}
      </div>
    </div>
  );
}
